const PREFERENCE_KEY = "nihongotech.languagePreference";
const PROMPT_DISMISSED_KEY = "nihongotech.languagePromptDismissed";

export type SiteLanguage = "en" | "pt";

function read(key: string): string | null {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}

function write(key: string, value: string) {
    try {
        localStorage.setItem(key, value);
    } catch {}
}

export function getLanguagePreference(): SiteLanguage | null {
    const value = read(PREFERENCE_KEY);
    return value === "en" || value === "pt" ? value : null;
}

export function saveLanguagePreference(language: SiteLanguage) {
    write(PREFERENCE_KEY, language);
}

export function isLanguagePromptDismissed(): boolean {
    return read(PROMPT_DISMISSED_KEY) === "true";
}

export function dismissLanguagePrompt() {
    write(PROMPT_DISMISSED_KEY, "true");
}

export function browserPrefersPortuguese(): boolean {
    if (typeof navigator === "undefined") return false;
    const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
    return languages.some((language) => /^pt\b/i.test(language || ""));
}
